import React from "react";
import { Route, Switch } from "react-router-dom";
import AppHeader from "./app-template/AppHeader";
import AppFooter from "./app-template/AppFooter";
import {
	FolioIngenio,
	FolioSearch,
	FolioCabin,
	FolioAbout,
	FolioResume,
} from "./app-template/AppContent";
import Landing from "./folio-landing/Landing";
import IEPView from "./folio-case-study-iep/IEPView";
// new Ingenio CS:
import IngenioIEPCS from "./cs-ingenio-iep/template";
import IgluSearchCS from "./cs-iglu-search/template";
import CabinSelectView from "./folio-case-study-cs/CabinView";
import AboutView from "./about/AboutView";
import ResumeView from "./resume/ResumeView";
import Error404 from "./app-template/error404";
// scroll restoration
import ScrollToTop from "./components/ScrollToTop";

function App() {
	return (
		<>
			<AppHeader />
			<ScrollToTop />
			<Switch>
				<Route path="/" exact component={Landing} />
				<Route path={FolioIngenio.path} component={IEPView} />
				<Route path={FolioIngenio.pathTemp} component={IngenioIEPCS} />
				<Route path={FolioSearch.path} component={IgluSearchCS} />
				<Route path={FolioCabin.path} component={CabinSelectView} />
				<Route path={FolioAbout.path} component={AboutView} />
				<Route path={FolioResume.path} component={ResumeView} />
				<Route component={Error404} />
			</Switch>

			<AppFooter />
		</>
	);
}

export default App;
